'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

// Fixed browser check - using typeof window !== 'undefined'
const isBrowser = typeof window !== 'undefined';

export default function PrelineLoader() {
    const pathname = usePathname();

    useEffect(() => {
        // Only run on client side
        if (!isBrowser) return;

        // Safely import and initialize Preline
        const initPreline = async () => {
            try {
                const module = await import('preline/preline');
                // Make sure window and HSStaticMethods exist before calling
                if (window && window.HSStaticMethods) {
                    setTimeout(() => {
                        window.HSStaticMethods.autoInit();
                    }, 100);
                }
            } catch (error) {
                console.error('Failed to initialize Preline:', error);
            }
        };

        initPreline();
    }, [pathname]);

    return null;
}
